import { appHooks } from "@app/app";
import { useRouter } from "@app/app/components/router/RouterContext";
import { useCustomNavigate } from "@app/app/hooks";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogHeightModes,
    DialogTitle,
    DialogVerticalPositions,
} from "@app/componentLibrary/ui/dialog";
import { Button } from "@ui";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

export interface INoAvailabilityModalProps {
    isCloseable?: boolean;
}

export const NoAvailabilityModal = ({ isCloseable = false }: INoAvailabilityModalProps) => {
    const { availability, isLoading, initialized } = appHooks.useBookingEngineStateContext();
    const [open, setOpen] = React.useState<boolean>(false);
    const { t } = useTranslation(["availability"]);
    const navigate = useCustomNavigate();
    const { route } = useRouter();
    const noAvailability = availability.length && !(availability[0]?.packages || []).length && !(availability[0]?.rooms || []).length;
    const activeStep = route.query.c; // c is the query key of the page
    const isAvailabilityStep = activeStep === "availability";

    const goToSearchPage = () => {
        navigate("?p=base&c=search");
        setOpen(false);
    };

    React.useEffect(() => {
        if (initialized && isAvailabilityStep && noAvailability) {
            setOpen(true);
        }
    }, [isLoading, initialized, isAvailabilityStep, noAvailability]);

    return open ? (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && isCloseable && setOpen(false)}>
            <DialogContent verticalPosition={DialogVerticalPositions.Middle} heightMode={DialogHeightModes.Fit} isCloseable={isCloseable}>
                <DialogHeader>
                    <DialogTitle>{t("search.changeSelection")}</DialogTitle>
                </DialogHeader>
                <div data-testid="no-availability-modal" className="relative z-30 bg-white rounded-lg">
                    <div className="p-6">
                        <p>{t("overview.noAvailabilityMsg")}</p>
                        <Button data-testid="update-search-btn" className="w-full mt-6" onClick={goToSearchPage}>
                            {t("overview.updateSearch")}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    ) : null;
};
